import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12 mb-20" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "col-md-6 mb-20" }
const _hoisted_9 = { class: "col-md-6 mb-20" }
const _hoisted_10 = { class: "col-12 mb-20" }
const _hoisted_11 = { class: "col-md-6 mb-20" }
const _hoisted_12 = { class: "col-md-6 mb-20" }
const _hoisted_13 = { class: "col-md-12 d-flex align-items-center justify-content-between mt-20" }
const _hoisted_14 = {
  type: "submit",
  class: "btn btn-success px-4 py-2"
}
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Photo de profil ", -1)),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.imagepreview)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.imagepreview,
                    class: "rounded-circle me-15",
                    style: {"width":"90px","height":"90px","object-fit":"cover"}
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: require('@/assets/images/NoImage.png'),
                    class: "rounded-circle me-15",
                    style: {"width":"90px","height":"90px","object-fit":"cover"}
                  }, null, 8, _hoisted_7)),
              _createElementVNode("div", null, [
                _createElementVNode("input", {
                  ref: "updateImgInput",
                  type: "file",
                  accept: "image/*",
                  class: "d-none",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoSelected && _ctx.logoSelected(...args)))
                }, null, 544),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary me-2",
                  onClick: _cache[1] || (_cache[1] = () => _ctx.updateImgInput?.click())
                }, " Choisir la photo "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelImage && _ctx.cancelImage(...args)))
                }, " Annuler ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom complet *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.name) = $event)),
              type: "text",
              class: "form-control shadow-none rounded-0",
              placeholder: "Nom complet",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Numéro de téléphone *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.phone) = $event)),
              type: "text",
              pattern: "^0[0-9]{9}$",
              class: "form-control shadow-none rounded-0",
              placeholder: "0XXXXXXXXX",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.phone]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Adresse électronique *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.email) = $event)),
              type: "email",
              class: "form-control shadow-none rounded-0",
              placeholder: "exemple@email.com",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Mot de passe *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.password) = $event)),
              type: "password",
              class: "form-control shadow-none rounded-0",
              placeholder: "Mot de passe",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.password]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Confirmation de mot de passe *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.c_password) = $event)),
              type: "password",
              class: "form-control shadow-none rounded-0",
              placeholder: "Confirmer mot de passe",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.c_password]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", _hoisted_14, [
              _cache[15] || (_cache[15] = _createTextVNode(" Enregistrer ", -1)),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                : _createCommentVNode("", true)
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-link text-danger"
            }, " Annuler ", -1))
          ])
        ])
      ], 32)
    ])
  ]))
}